import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Translate } from 'react-localize-redux';
import SearchTextField from '../../../components/molecules/SearchTextField/SearchTextField';
import Spinner from '../../../components/widgets/Spinner';
import { PERFORMANCE_COLORS } from '../../consts';
import { SunburstNodeType } from '../../types';
import SunburstChart from './SunburstChart';
import css from './Sunburst.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS';

const Sunburst = ({ data, isLoading, error, hasQueried }) => {
    const [search, setSearch] = useState('');

    const isNoData = isLoading || !!error || !data?.length;

    return (
        <div className={css.container}>
            <div className={css.toolbar}>
                <SearchTextField
                    search={search}
                    onSearchChange={setSearch}
                    placeholder={`${TRANSLATION_PREFIX}.SUNBURST.SEARCH_PLACEHOLDER`}
                    className={css.searchBox}
                    disabled={isNoData}
                />
            </div>
            <div className={css.legend}>
                {Object.entries(PERFORMANCE_COLORS).map(([key, color]) => (
                    <div key={key} className={css.legendItem}>
                        <div className={css.legendColor} style={{ backgroundColor: color }} />
                        <Translate id={`${TRANSLATION_PREFIX}.LEGEND.${key}`} />
                    </div>
                ))}
            </div>
            <div className={css.content}>
                {isLoading ? (
                    <Spinner show />
                ) : error ? (
                    <Translate id={`${TRANSLATION_PREFIX}.SUNBURST.ERROR_STATE`} />
                ) : !data?.length ? (
                    <Translate id={`${TRANSLATION_PREFIX}.SUNBURST.${hasQueried ? 'NO_RESULTS' : 'EMPTY_STATE'}`} />
                ) : (
                    <SunburstChart nodes={data} search={search} />
                )}
            </div>
        </div>
    );
};

Sunburst.propTypes = {
    data: PropTypes.arrayOf(SunburstNodeType),
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    hasQueried: PropTypes.bool,
};

export default Sunburst;
